import { Controller } from "@hotwired/stimulus"

// Mobile-only: the filter modal is one form rendered as a search section (query
// + content-type/style chips) with the advanced filters (channel, collection,
// sort) as a collapsible accordion below it. "More filters" toggles data-screen
// between "search" (collapsed) and "filters" (advanced revealed inline, below
// the search section — the user scrolls to reach it, they don't leave the
// screen). Desktop shows everything at once in the sidebar, so the toggle button
// is md:hidden there and this attribute is inert (CSS only acts on it below md).
//
// The state lives on THIS element's data-screen attribute. Crucially, the
// index.turbo_stream response only swaps leaf regions *inside* it
// (#search_results, #genre_filters, …) and never this container — so a live
// keystroke or chip tap re-renders results and facets without collapsing the
// accordion the user just opened. (Putting the toggle on a replaced region would
// reset the view on every keystroke — the main regression to guard against.)
//
// The channel picker is a third screen ("channels"): on mobile it's too long to
// sit inline in the filters accordion, so a compact "Channel" row opens it as a
// dedicated screen and a back arrow returns to the filters screen. Desktop shows
// the channel list inline in the sidebar, so these are inert there (CSS only
// routes screens below md).
//
// On open, modal_filters_controller resets us to "search" (collapsed); on cancel
// it restores the snapshot HTML, which carries data-screen="search" with it.
export default class extends Controller {
  toggle() {
    this.element.dataset.screen = this.element.dataset.screen === "filters" ? "search" : "filters"
  }

  showChannels() {
    this.element.dataset.screen = "channels"
  }

  showFilters() {
    this.element.dataset.screen = "filters"
  }
}
